module.exports = __webpack_public_path__ + "faed0e64817196bd7192a70c1f3ac2dd.svg";